'use client';

import { useEffect } from 'react';

import type { Theme } from '@/lib/theme/theme-matchers';

import { useThemeController } from './theme-provider';

export function StatusPageThemeSetter({ theme }: { theme: Theme }) {
  const { setTheme } = useThemeController();

  useEffect(() => {
    setTheme(theme);
  }, [setTheme, theme]);

  return null;
}
